"use client";
import { useState } from "react";
import { Plus, X } from "lucide-react";

const MerchantFaqsAccordion = ({ faq, index }: { faq: any; index: number }) => {
  const [isOpen, setIsOpen] = useState(index === 0);

  return (
    <div className="group">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-start justify-between gap-4 px-0 py-4 text-left border-b transition-colors duration-200
          ${isOpen ? "border-blue-600/20" : "border-slate-100 hover:border-slate-200"}`}
      >
        {/* number + question */}
        <div className="flex items-start gap-4 min-w-0">
          <span
            className={`text-[11px] font-black tabular-nums shrink-0 mt-0.5 transition-colors
              ${isOpen ? "text-blue-600" : "text-slate-300 group-hover:text-slate-400"}`}
          >
            {String(index + 1).padStart(2, "0")}
          </span>
          <span
            className={`text-[15px] font-semibold leading-snug transition-colors duration-200
              ${isOpen ? "text-slate-900" : "text-slate-700 group-hover:text-slate-900"}`}
          >
            {faq.question}
          </span>
        </div>

        {/* toggle icon */}
        <div
          className={`shrink-0 w-7 h-7 rounded-lg flex items-center justify-center transition-all duration-300 mt-0.5
            ${isOpen
              ? "bg-blue-600 text-white"
              : "bg-slate-100 text-slate-400 group-hover:bg-blue-50 group-hover:text-blue-600"
            }`}
        >
          {isOpen
            ? <X    size={14} strokeWidth={2.5} />
            : <Plus size={14} strokeWidth={2.5} />
          }
        </div>
      </button>

      {/* answer */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out
          ${isOpen ? "max-h-[400px] opacity-100" : "max-h-0 opacity-0"}`}
      >
        <div className="pl-9 pr-4 py-4 pb-5">
          <p className="text-slate-500 text-sm leading-relaxed font-medium">
            {faq.answer}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MerchantFaqsAccordion;
